import { FormContainer, Treturn, useFetch } from "@4uhub/lib4uhub";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import {
  templateGeneralsSchema,
  TTemplateGeneralsForm,
} from "./templateGeneralSchema";
import {
  createTemplateGeneral,
  getTemplateGeneralById,
  updateTemplateGeneralById,
} from "../../../../../services/templateGeneral.service";
import { TemplateGeneralFields } from "./TemplateGeneralFields";

const translationPath = "chatBot.page.automations.templateGeneral.";

const TemplateGeneral = () => {
  const { t } = useTranslation();

  const { sendRequest: save, loading: sLoading } = useFetch(
    createTemplateGeneral,
  );

  const { sendRequest: update, loading: uLoading } = useFetch(
    updateTemplateGeneralById,
  );

  const { sendRequest: get, loading: gLoading } = useFetch(
    getTemplateGeneralById,
  );

  const updateHandler = (v: TTemplateGeneralsForm, id: string) => {
    return update({
      item: {
        id: id,
        name: v.name,
        templateGeneralTypeId: v.templateGeneralType.id,
        contentHeader: v.contentHeader ? v.contentHeader : null,
        contentFooter: v.contentFooter ? v.contentFooter : null,
        enable: v.enable,
        useHtml: v.useHtml,
      },
      id: id,
    });
  };

  const saveHandler = (v: TTemplateGeneralsForm) =>
    save({
      name: v.name,
      templateGeneralTypeId: v.templateGeneralType.id,
      contentHeader: v.contentHeader ? v.contentHeader : null,
      contentFooter: v.contentFooter ? v.contentFooter : null,
      enable: v.enable,
      useHtml: v.useHtml,
    });

  const getHandler = useCallback(
    async (id: string): Promise<Treturn<TTemplateGeneralsForm>> => {
      const { data, success } = await get(id);

      if (data) {
        const newData: TTemplateGeneralsForm = {
          ...data,
          name: data.name,
          contentHeader: data.contentHeader,
          contentFooter: data.contentFooter,
          templateGeneralType: {
            id: data.templateGeneralType.id,
            name: data.templateGeneralType.name,
          },
          enable: data.enable,
        };
        return { data: newData, success: true };
      }
      return { data, success };
    },
    [get],
  );

  const loading = sLoading || uLoading || gLoading;
  return (
    <FormContainer<TTemplateGeneralsForm>
      title={t(translationPath + "title")}
      subtitle=""
      getFunction={getHandler}
      saveFunction={saveHandler}
      updateFunction={updateHandler}
      loading={loading}
      schema={templateGeneralsSchema}
      defaultValues={{ useHtml: false }}
      fields={() => <TemplateGeneralFields />}
    />
  );
};

export default TemplateGeneral;
